import { CostBasisMethods, FlowTypes } from '@interfaces/models';

export interface RecipientValidationHoldings {
  cusip: string;
  symbol: string;
  amountIndicator: string;
  amount: number;
  settlementFund: boolean;
  costBasisMethod?: CostBasisMethods;
}

/**
 * Gifting is the only transactionType we currently support. By hardcoding
 * the transactionType enum for gifting we are setting ourselves up for
 * cleaner discriminated union approach to request body as the request bodys
 * for Internal Transfers, etc may look different
 */
export interface RecipientValidationRequest {
  toAccountNumber: string;
  toAccountName: string;
  fromAccountNumber?: string;
  holdings: RecipientValidationHoldings[];
  transactionType: FlowTypes.GIFTING;
}

export enum RecipientValidationFailureReason {
  RECEIVING_CLIENT_ID_NOT_FOUND = 'RECEIVING_CLIENT_ID_NOT_FOUND',
  RECEIVING_ACCOUNT_NOT_FOUND = 'RECEIVING_ACCOUNT_NOT_FOUND',
  RECEIVING_ACCOUNT_NAME_MISMATCH = 'RECEIVING_ACCOUNT_NAME_MISMATCH',
  INELIGIBLE_HOLDINGS_TO_CASH_PLUS_ACCOUNT = 'INELIGIBLE_HOLDINGS_TO_CASH_PLUS_ACCOUNT',
  RECEIVING_ACCOUNT_IS_AN_IRA = 'RECEIVING_ACCOUNT_IS_AN_IRA',
  VCD_TO_TA_OR_MANAGED_ACCOUNT_NOT_ALLOWED = 'VCD_TO_TA_OR_MANAGED_ACCOUNT_NOT_ALLOWED',
  REQUEST_BODY_IS_INVALID = 'REQUEST_BODY_IS_INVALID',
  TO_ACCOUNT_RESTRICTIONS_PVBA = 'TO_ACCOUNT_RESTRICTIONS_PVBA',
  TO_ACCOUNT_RESTRICTIONS_MISC = 'TO_ACCOUNT_RESTRICTIONS_MISC',
  TO_ACCOUNT_RESTRICTIONS_CLRQ = 'TO_ACCOUNT_RESTRICTIONS_CLRQ',
  TO_ACCOUNT_RESTRICTIONS_RCLM = 'TO_ACCOUNT_RESTRICTIONS_RCLM',
  TO_ACCOUNT_RESTRICTIONS_NOD = 'TO_ACCOUNT_RESTRICTIONS_NOD',
  TO_ACCOUNT_RESTRICTIONS_AMLT = 'TO_ACCOUNT_RESTRICTIONS_AMLT',
  TO_ACCOUNT_RESTRICTIONS_CIP = 'TO_ACCOUNT_RESTRICTIONS_CIP',
  TO_ACCOUNT_RESTRICTIONS_FIP = 'TO_ACCOUNT_RESTRICTIONS_FIP',
  TO_ACCOUNT_RESTRICTIONS_CAND = 'TO_ACCOUNT_RESTRICTIONS_CAND',
  TO_ACCOUNT_RESTRICTIONS_ESCH = 'TO_ACCOUNT_RESTRICTIONS_ESCH',
  TO_ACCOUNT_RESTRICTIONS_DIMC = 'TO_ACCOUNT_RESTRICTIONS_DIMC',
  TO_ACCOUNT_RESTRICTIONS_FRAD = 'TO_ACCOUNT_RESTRICTIONS_FRAD',
  TO_ACCOUNT_RESTRICTIONS_RPO = 'TO_ACCOUNT_RESTRICTIONS_RPO',
  TO_ACCOUNT_RESTRICTIONS_MVTA = 'TO_ACCOUNT_RESTRICTIONS_MVTA',
  TO_ACCOUNT_RESTRICTIONS_ACTR = 'TO_ACCOUNT_RESTRICTIONS_ACTR',
  RECEIVING_ACCOUNT_INVALID_OPTION_PERMISSION = 'RECEIVING_ACCOUNT_INVALID_OPTION_PERMISSION',
  RECEIVING_ACCOUNT_OPTIONS_PERMISSION_INSUFFICIENT = 'RECEIVING_ACCOUNT_OPTIONS_PERMISSION_INSUFFICIENT',
}

interface BaseRecipientValidationResponse {
  valid: boolean;
  failureReasons?: RecipientValidationFailureReason[];
}

export interface ExternalRecipientValidationResponse extends BaseRecipientValidationResponse {
  external: true;
}

export interface InternalRecipientValidationResponse extends BaseRecipientValidationResponse {
  external: false;
}

export type RecipientValidationResponse =
  | ExternalRecipientValidationResponse
  | InternalRecipientValidationResponse;

export interface RecipientValidationMultiRequestItem {
  toAccountNumber: string;
  toAccountName: string;
  fromAccountNumber?: string;
  holdings: RecipientValidationHoldings[];
  transactionType: FlowTypes;
}

export type RecipientValidationMultiRequest = RecipientValidationMultiRequestItem[];

export interface RecipientValidationMultiResponseItem {
  toAccountNumber: string;
  valid: boolean;
  failureReasons: RecipientValidationFailureReason[];
  error?: boolean;
}

export type RecipientValidationMultiResponse = RecipientValidationMultiResponseItem[];
